import {useAnalytics, Link, Text, Button} from 'bigdatr-style';
import {Ul} from 'bigdatr-style/layout';
import React from 'react';
import rqApi from '~/api';
import {useRoutes} from '~/app/Router';

export default function UiImprovements() {
    const routes = useRoutes();
    const analytics = useAnalytics();
    const submitTrackingForm = rqApi.useSubmitHubspotForm();

    return (
        <>
            <p>We&apos;ve redesigned your competitor tools to help you work faster:</p>

            <Ul>
                <li>
                    Larger creative displays and smoother scrolling make reviewing content quicker
                    and more intuitive.
                </li>
                <li>
                    Find exactly what you need in seconds by selecting filters and running complex
                    searches in one, simplified view.
                </li>
                <li>
                    With enhanced navigation across the platform, you can now access your most-used
                    features with fewer clicks.
                </li>
            </Ul>

            <p>
                <Button
                    onClick={() => {
                        submitTrackingForm.mutate({formId: 'fd01e124-98b5-463d-84ad-8318805517d6'});
                        routes.exploreCreative.push({});
                    }}
                >
                    Try it now →
                </Button>
            </p>

            <p>Your feedback matters! Tell us what you think as you explore these updates.</p>

            <p>
                <Text textStyle="strong">Questions?</Text> Chat with us or request a team
                walkthrough <Link onClick={() => analytics.chat()}>→</Link>
            </p>
        </>
    );
}
